import { computed, makeObservable, observable } from 'mobx'
import { type IIconsVector } from 'shared/ui/Icon/icons'
import { type IInboxKey } from 'entities/Inbox/model/types'
import { TYPES_INBOX } from 'entities/Inbox/store/types'
import { type IResponseUnifiedInbox } from 'entities/Inbox/api/types'
import { type ICallSettingsItem } from 'entities/Organization/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BaseInbox } from 'entities/Inbox/model/BaseInbox'

export class UnifiedInbox extends BaseInbox<IResponseUnifiedInbox> {
  id: number
  type: 'unified-inbox'
  root_tree!: string
  name = 'All inboxes'
  teamsIds!: number[]
  isMuted = false
  color_coding_enabled = false
  origin!: IResponseUnifiedInbox
  isPFTInbox = false
  call_via_aircall!: ICallSettingsItem | null

  constructor(item: IResponseUnifiedInbox, private _entities: IEntitiesStore) {
    super(item)

    this.id = item.id
    this.type = 'unified-inbox'
    this.syncOrigin(item)

    makeObservable(this, {
      is_favorite: observable,
      root_tree: observable,
      unread: computed,
      unread_calls: computed,
      unread_messages_count: computed,
      unread_mentions_count: computed,
      unreadCount: computed,
    })
  }

  syncOrigin = (origin: IResponseUnifiedInbox & { root_tree?: string }) => {
    this.id = origin.id
    this.is_favorite = origin.is_favorite
    this.root_tree = origin.root_tree || this.initRootTree()
    this.teamsIds = []
    this.color_coding_enabled = origin.color_coding_enabled
    this.origin = origin
    this.call_via_aircall = origin.call_via_aircall
  }

  get sharedInboxes() {
    return this._entities.inboxesStore.sharedInboxes
  }

  get unread() {
    return this.sharedInboxes.reduce((state, item) => {
      return state + item.unread
    }, 0)
  }

  get unread_calls() {
    return this.sharedInboxes.reduce((state, item) => {
      return state + item.unread_calls
    }, 0)
  }

  get unread_messages_count() {
    return this.sharedInboxes.reduce((state, item) => {
      return state + item.unread_messages_count
    }, 0)
  }

  get unread_mentions_count() {
    return this.sharedInboxes.reduce((state, item) => {
      return state + item.unread_mentions_count
    }, 0)
  }

  get unreadCount() {
    return this.unread_messages_count + this.unread_mentions_count
  }

  get isCreateGroup() {
    return false
  }

  get icon(): IIconsVector {
    return 'all_inboxes'
  }

  get inboxType() {
    return TYPES_INBOX.UNIFIED
  }

  get typeKey(): IInboxKey {
    return 'unified'
  }

  get bodyUpdateUserTeam() {
    return {
      id: this.id,
      type: this.inboxType,
    }
  }

  get bodyUpdateTeamsGroupsById() {
    return {
      name: this.name,
      description: '',
      team_ids: [],
    }
  }

  get idTree() {
    return `${this.root_tree}_${this.id}`
  }

  get isCallViaAircall() {
    return this.call_via_aircall?.is_active
  }
}
